var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-info d-flex flex-column",class:[_vm.betslip.betStatus == 'false' ? 'cancelBet':'', _vm.betslip.marketType != 3 ? 'grey' : 'red']})
}
var staticRenderFns = []

export { render, staticRenderFns }